import * as types from './types';
import { loading, success, error } from 'State/actions';
import { replace } from 'react-router-redux';

export const fetchVendorEleFileConfig = vendorId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VENDOR_ELE_FILE_CONFIG_FETCHING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `InvVendors/GetEFFByVendor/${vendorId}`
      );
      dispatch(
        success(types.VENDOR_ELE_FILE_CONFIG_FETCH, {
          configData: response.data.Data,
        })
      );
    } catch (ex) {
      dispatch(error(types.VENDOR_ELE_FILE_CONFIG_FETCH_ERROR, ex));
    }
    dispatch(loading(types.VENDOR_ELE_FILE_CONFIG_FETCHING, false));
  };
};

export const saveElectronicFileConfig = model => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VENDOR_ELE_FILE_CONFIG_SUBMITTING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'InvVendors/SaveVendorEFF',
        model
      );
      dispatch(success(types.VENDOR_ELE_FILE_CONFIG_SUBMIT));
      dispatch(replace('/vendorsetup'));
    } catch (ex) {
      dispatch(error(types.VENDOR_ELE_FILE_CONFIG_SUBMIT_ERROR, ex));
    }
    dispatch(loading(types.VENDOR_ELE_FILE_CONFIG_SUBMITTING, false));
  };
};

export const clearVendorElectronicFileConfigErrorSuccess = () => {
  return {
    type: types.VENDOR_ELE_FILE_CONFIG_CLEAR_ERROR_SUCCESS,
  };
};

export const clearVendorElectronicFileConfigData = () => {
  return { type: types.VENDOR_ELE_FILE_CONFIG_CLEAR_DATA };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/eleFileConfig/actions.js